<!-- #curation (the keystone, gate-covered) -->
@if (curationOpen()) {
    <div id="curation" class="curation-modal">
        <ft-modal-chrome-ng size="lg" [doneVisible]="false" (cancel)="closeModal()">
            <ft-curation-modal-ng [guest]="guest"
                [isShowTimeline]="model?.isShowTimeline"
                [bulkNav]="bulkNav"
                (bulkNext)="moveNext()"
                (ratePhoto)="ratePhoto($event)"
                (rateCaption)="rateCaption($event)"
                (rateQuote)="rateQuote($event)"
                (advanceToFinal)="advanceToFinal()"
                (pass)="pass()"
                (showImageModal)="showImageModal()"
                (showReplaceModal)="showReplaceModal()"
                (reprocessImage)="reprocessImage()"
                (downloadHighResImage)="downloadHighResImage()"
                (openAdvocatePage)="openAdvocatePage()"
                (broadcastStory)="broadcastStory()"
              />
            <!-- @if content projects into the wildcard slot, so the ngProjectAs container
                 keeps the bulk nav in the chrome's [modalFooterContent] footer slot. -->
            <ng-container ngProjectAs="[modalFooterContent]">
                @if (bulkNav) {
                    <ft-bulk-curation-nav-ng modalFooterContent
                        [hasPhoto]="bulkNav.hasPhoto"
                        [isDone]="bulkNav.isDone"
                        [total]="bulkNav.total"
                        (next)="moveNext()"
                      />
                }
            </ng-container>
        </ft-modal-chrome-ng>
    </div>
}

<!-- #curationImageDetails (gate-covered cross-modal) -->
@if (detailsOpen()) {
    <div id="curationImageDetails" class="curation-modal curation-image-details-modal">
        <ft-modal-chrome-ng
            size="sm"
            [cancelVisible]="false"
            [footerCancelVisible]="true"
            footerAlign="center"
            (done)="savePhotoDetails()"
            (cancel)="cancelImagePanel('details')"
        >
            <ft-curation-image-details-ng [guest]="guest" />
        </ft-modal-chrome-ng>
    </div>
}

<!-- #curationImageReplacement (gate-covered cross-modal, staff-only) -->
@if (replacementOpen()) {
    <div id="curationImageReplacement" class="curation-modal curation-image-replacement-modal">
        <ft-modal-chrome-ng
            size="sm"
            [cancelVisible]="false"
            [footerCancelVisible]="true"
            footerAlign="center"
            (done)="replacePhoto()"
            (cancel)="cancelImagePanel('replacement')"
        >
            <ft-curation-image-replacement-ng [uploadUrl]="uploadUrl"
                (imageUploaded)="replacePhoto()"
              />
        </ft-modal-chrome-ng>
    </div>
}

<!-- #curationShare (DEAD chain — no in-app caller; rendered for fidelity) -->
@if (shareOpen()) {
    <div id="curationShare" class="curation-modal">
        <ft-modal-chrome-ng size="lg" [doneVisible]="false" [cancelVisible]="false" footerAlign="center">
            <ft-curation-share-ng [sharing]="sharing()"
                [property]="property"
                [guest]="guest"
                [quoteSize]="quoteSize()"
                [captionSize]="captionSize()"
                [shareMessageLimit]="shareMessageLimit()"
                (previewPost)="createShareImage()"
                (cancelClicked)="showCurationModal()"
              />
        </ft-modal-chrome-ng>
    </div>
}

<!-- #shareImageCreated (DEAD chain) -->
@if (shareCreatedOpen()) {
    <div id="shareImageCreated" class="curation-modal curation-ready-modal">
        <ft-modal-chrome-ng size="lg" [footerVisible]="false" [cancelVisible]="false">
            <ft-share-image-created-ng [sharing]="sharing()"
                (download)="downloadShareImage($event)"
                (share)="openOAuth()"
                (cancelClicked)="showCurationModal()"
              />
        </ft-modal-chrome-ng>
    </div>
}

<!-- #createImageProgress (DEAD chain) -->
@if (progressOpen()) {
    <div id="createImageProgress" class="curation-modal curation-progress-modal">
        <ft-modal-chrome-ng [doneVisible]="false" [cancelVisible]="false">
            <ft-curation-create-progress-ng />
        </ft-modal-chrome-ng>
    </div>
}
